var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[(_vm.windowWidth >= 992)?_c('v-logo'):_vm._e(),(_vm.windowWidth >= 992)?_c('v-cart'):_vm._e(),_c('div',{staticClass:"sidebar__inner"},[_c('v-canvas',{attrs:{"maxHeight":_vm.height}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }